'use strict';

var carousels = require('./carousels');

var einsteinObserver = require('./einstein').einsteinObserver;
var baseProductTileCarousels = carousels.blogProductTileCarousels;

module.exports = function () {
    einsteinObserver('.einstein-slot', baseProductTileCarousels);
};
